module.exports = __webpack_public_path__ + "static/media/step1.043d4e17.png";